import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '@/hooks/constants';
import Service from '@/lib/App';

export function useGetUpcomingBlackday(options?: { [key: string]: any }) {
  return useQuery({
    queryKey: queryKeys.planner.getUpcomingBlackday,
    queryFn: () => Service.planner.fetchUpcomingBlackday(),
    ...options,
  });
}

export function useGetAllActiveBlackdays(options?: { [key: string]: any }) {
  return useQuery({
    queryKey: queryKeys.planner.getAllActiveBlackdays,
    queryFn: () => Service.planner.fetchAllActiveBlackdays(),
    ...options,
  });
}
